var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mask)?_c('h2',[_vm._v(_vm._s(_vm.mask.title))]):_vm._e(),_vm._v(" "),(_vm.maskData)?_c('CheckableTreeView',{ref:"displayMaskTreeView",attrs:{"data":_vm.maskData,"prettyDisplay":true}}):_c('div',[_vm._v(_vm._s(_vm.$t('reports.errors.no_mask_selected')))])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4519036c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/MaskDisplay.vue
// module id = C3sY
// module chunks = 70